<script>
import "mv-full-page/lib-dist/mv-full-page.css";
import MvFullPage from "mv-full-page";

import { mapGetters } from "vuex";

import Jumping from "comp/common/Jumping";
import Corporate from "comp/common/Corporate";
import Xgplayer from "comp/common/VideoPlayer/Xgplayer.vue";
import Drop from "./components/Drop.vue";

import {
  richTextImgHandler,
  textLenHandler,
  filtersRichtext,
  timeToSc,
  aesDecrypt,
} from "@/utils/common.js";
import { formatDate } from "@/utils/filters.js";

import {
  getPeopleCongress,
  getDynamic,
  recordsVideoClick,
  getCoursewareBaseApi,
  getLivingTime,
} from "@/api/partyTop"; // getLivingUrl

import { getCommunityIntro } from "@/api/pageData";

export default {
  components: { Jumping, Corporate, MvFullPage, Xgplayer, Drop },
  data() {
    return {
      village: localStorage.getItem("currentCommunity") || "",
      hasLiving: false,
      // 地区
      area: "",
      liveTheme: "",
      liveTitle: "",
      allVideoInfoList: [],
      all2024CwareVideoInfoList: [],
      themeList: [],
      currentThemeName: "",
      videoInfoList: [],
      videoInfoList2024Cware: [],
      currentVideoInfoIndex: 0,
      currentVideoInfo: {},
      dynamicRecommend: [],
      // 2024百部课件下基层菜单
      dropShow: true,
      coursewareBaseOption: [],
      current2024CwareTheme: "",
      /* page2 */
      allDynamicList: [],
      dynamicTypeList: [],
      currentType: "",
      dynamicInfoList: [],
      currentDynamicIndex: 0,
      currentDynamicInfo: {},
      /* page config */
      isV: true,
      currentPage: 1,
      bgArr: [
        { isBg: true, src: require("imgs/partyTop/page-bg.webp") },
        { isBg: true, src: require("imgs/partyTop/congress-bg.webp") },
      ],
    };
  },
  computed: {
    ...mapGetters({
      navList: "config/getNavList",
      currentPageTitle: "config/getCurrentPageTitle",
    }),
    curLiveTheme() {
      return this.hasLiving
        ? "学习贯彻党的二十届四中全会精神"
        : "学习贯彻党的二十届四中全会精神";
    },
    currentThemeIndex() {
      let themeIdx = 0;
      this.themeList.forEach((item, idx) => {
        if (item.title === this.currentThemeName) themeIdx = idx;
      });
      return themeIdx;
    },
    currentAllVideoInfoList() {
      return this.currentThemeName === "2024百部课件下基层"
        ? this.all2024CwareVideoInfoList
        : this.allVideoInfoList;
    },
    currentVideoInfoList() {
      return this.currentThemeName === "2024百部课件下基层"
        ? this.videoInfoList2024Cware
        : this.videoInfoList;
    },
    videoInfoListAfter() {
      return this.currentVideoInfoList;
    },
    videoUrlArr() {
      const { videoPath, sdVideoPath } = this.currentVideoInfo;
      const url = sdVideoPath || "";
      const urlHigh = videoPath || "";
      return [urlHigh, url];
    },
  },
  watch: {
    videoInfoListAfter: {
      handler(newVal) {
        this.currentVideoInfo = {};
        this.currentVideoInfo = newVal[0] || {};
        if (newVal?.length > 0) this.recordsVideoClickReq();
      },
      immediate: true,
      deep: true,
    },
    currentVideoInfoIndex(newVal) {
      if (newVal === 0) {
        this.$nextTick(() => {
          setTimeout(() => {
            const parent = document.querySelector(".congress-video-list");
            parent.scrollTo({ top: 0, behavior: "smooth" });
          }, 200);
        });
      }
    },
    currentDynamicInfo: {
      handler(newVal) {
        this.$nextTick(() => {
          setTimeout(() => {
            const parent = document.querySelector(".rich-text-container");
            parent.scrollTo({ top: 0, behavior: "smooth" });
          }, 200);
        });
      },
    },
  },
  methods: {
    richTextImgHandler,
    textLenHandler,
    filtersRichtext,
    aesDecrypt,
    getLivingTimeReq() {
      getLivingTime().then((res) => {
        console.log("zhi'bo'qing'kzhiboqingk",res);

        const { code, msg } = res;
        if (code === 0) {
          // 获取直播结束时间，获取直播备注，获取房间ID
          const { endTime, liveMemo, liveRoomID } = msg;
          // 获取直播主题，获取直播区域，获取直播标题
          const [liveTheme, liveArea, liveTitle] = liveMemo.split(",");
          // 存储直播主题到该页面
          this.liveTheme = liveTheme || "";
          // 存储地区和标题到页面并展示
          this.liveTitle = `${liveArea || ""}${liveTitle || ""}`;
          // 格式化直播结束时间和当前时间
          const endTimeFormat =
            formatDate(endTime || "", "yyyy-MM-dd hh:mm:ss") || "";
          const nowDate = formatDate(new Date(), "yyyy-MM-dd hh:mm:ss");
          // 获取房间ID的最后一个字符，判断是否为乡或镇，如果是则判断直播是否开始
          const word = liveRoomID?.[liveRoomID?.length - 1] || liveRoomID;
          // 获取当前乡镇
          const currentVillage = this.area || "";

          // 判断直播是否开始
          this.hasLiving =
            timeToSc(nowDate) < timeToSc(endTimeFormat) &&
            (liveRoomID === currentVillage || liveRoomID == "洪雅县");
        } else this.hasLiving = false;
        // this.bgArr[0].src = this.hasLiving ? this.liveBg : imgPath(sessionStorage.getItem('livingBg'))
      });
    },
    getCoursewareBase() {
      getCoursewareBaseApi({ village: this.village }).then((res) => {
        if (res.code === 0) {
          this.currentThemeName = "学习贯彻党的二十届四中全会精神";

          this.all2024CwareVideoInfoList = res?.msg || [];
          this.videoInfoList2024Cware = res?.msg[0]?.list || [];
          this.coursewareBaseOption = res?.msg.map((item, index) => {
            return { label: item.title, value: index };
          });
          this.current2024CwareTheme =
            this.coursewareBaseOption[0]?.label || "";
        }
      });
    },
    onDropBarClick(dropShow) {
      if (this.currentThemeName === "2024百部课件下基层") return;
      this.currentThemeName = "2024百部课件下基层";
      this.current2024CwareTheme = this.coursewareBaseOption[0]?.label || "";
      this.onDropClick({ label: this.current2024CwareTheme });
    },
    onDropClick({ label }) {
      this.current2024CwareTheme = label;
      this.currentAllVideoInfoList.forEach((item) => {
        if (item.title === label) {
          if (item?.list?.length > 0) {
            this.videoInfoList2024Cware = [...item.list];
            this.currentVideoInfoIndex = 0;
            this.currentVideoInfo = item.list[0];
          } else {
            this.videoInfoList2024Cware = [];
            this.currentVideoInfoIndex = 0;
            this.currentVideoInfo = {};
          }
        }
      });
    },
    /* page1 */
    toLiving() {
      this.$router.push("/partyLivingM3U8");
    },
    toPartyTop(path) {
      if (path) this.$router.push(path);
    },
    rollEnd(e) {
      if (e == 2 && !this.allDynamicList?.length) this.getDynamicReq();
    },
    onCheckAllDynamic() {
      this.currentPage = 2;
    },
    onChoseVideoListItem(v, i) {
      this.currentVideoInfoIndex = i;
      this.currentVideoInfo = v;
      this.recordsVideoClickReq();
    },
    onChoseTheme(v) {
      this.currentThemeName = v.title;
      this.currentAllVideoInfoList.forEach((item) => {
        if (item.title === v.title) {
          if (item?.list?.length > 0) {
            this.videoInfoList = item.list;
            this.currentVideoInfoIndex = 0;
            this.currentVideoInfo = item.list[0];
          } else {
            this.videoInfoList = [];
            this.currentVideoInfoIndex = 0;
            this.currentVideoInfo = {};
          }
        }
      });
    },
    onTypeClick(v) {
      this.currentType = v.title;
      this.allDynamicList.forEach((item) => {
        if (item.title === v.title) {
          if (item?.list?.length > 0) {
            this.dynamicInfoList = item.list;
            this.currentDynamicIndex = 0;
            this.currentDynamicInfo = item.list[0];
          } else {
            this.dynamicInfoList = [];
            this.currentDynamicIndex = 0;
            this.currentDynamicInfo = {};
          }
        }
      });
    },
    videoEnd() {
      this.currentVideoInfoIndex + 1 === this.videoInfoList?.length
        ? (this.currentVideoInfoIndex = 0)
        : (this.currentVideoInfoIndex += 1);
      this.currentVideoInfo = this.videoInfoList[this.currentVideoInfoIndex];
      this.recordsVideoClickReq();
    },
    onReturnHome() {
      const home =
        this.navList?.find(
          (item) => item.templateName === this.currentPageTitle
        )?.path || "/";
      this.$router.replace(home);
    },
    /* page2 */
    onChoseDynamicListItem(v, i) {
      this.currentDynamicIndex = i;
      this.currentDynamicInfo = v;
    },
    onChoseDynamicListItemPage1(v, i) {
      this.currentPage = 2;
      if (this.allDynamicList?.length) {
        this.currentType = this.dynamicTypeList[0].title;
        this.dynamicInfoList = this.allDynamicList[0].list;
        this.currentDynamicIndex = i;
        this.currentDynamicInfo = v;
      }
    },
    onTopClick() {
      this.currentPage = 1;
    },

    setClass(idx) {
      return `congress-video-list-${idx}`;
    },
    initPageData() {
      getPeopleCongress({ village: this.village }).then((res) => {
        if (res.code === 0) {
          const { msg = [], msg2 = [] } = res;
          this.allVideoInfoList = msg || [];
          const themeArr = [];
          msg?.length > 0 &&
            msg.forEach((item) => themeArr.push({ title: item.title }));
          this.themeList = [...this.themeList, ...themeArr];
          // this.currentThemeName = this.themeList[0].title
          this.currentThemeName = msg[0].title;
          this.videoInfoList = msg[0].list || [];
          // this.currentVideoInfo = this.videoInfoListAfter[0] || {}
          this.dynamicRecommend = msg2;
        }
      });
    },
    getDynamicReq() {
      getDynamic({ village: this.village }).then((res) => {
        if (res.code === 0) {
          const { msg = [] } = res;
          this.allDynamicList = msg;
          this.dynamicTypeList = [];
          msg?.length > 0 &&
            msg.forEach((item) =>
              this.dynamicTypeList.push({ title: item.title })
            );
          this.currentType = this.dynamicTypeList[0].title;
          this.dynamicInfoList = msg[0].list || [];
          this.currentDynamicInfo = msg[0].list[0] || {};
        }
      });
    },
    recordsVideoClickReq() {
      const params = {
        village: this.village,
        headline: this.currentThemeName,
        title: this.currentVideoInfo.videoTitle,
      };
      recordsVideoClick(params);
    },
  },
  async created() {
    await getCommunityIntro({
      village: this.village,
      title: "社区简介",
      userid: 0,
    }).then((res) => {
      if (res.code === 0) {
        this.area = res.township || "";
      }
    });
    await this.initPageData();
    await this.getCoursewareBase();
    this.getLivingTimeReq();
  },
};
</script>

<template>
  <div class="page-container">
    <mv-full-page
      :is-pointer="false"
      pointer-pos="right"
      :is-v="isV"
      :pages="2"
      :page.sync="currentPage"
      :bg-arr="bgArr"
      :is-cache="false"
      :transition="{
        duration: '500ms', // 动画时长
        timingFun: 'ease', // 动画速度曲线
        delay: '0s', // 动画延迟
      }"
      @rollEnd="rollEnd"
    >
      <template #page1>
        <div class="page1">
          <div class="page-title-box page-title-box-nolive">
            <div class="live-text-fir">
              <el-image
                :src="require('imgs/partyTop/live-logo.webp')"
                class="live-logo"
              />
              <p :text="curLiveTheme" class="live-text">
                {{ curLiveTheme }}
              </p>
            </div>
          </div>
          <div v-if="hasLiving" class="living-btn" @click="toLiving">
            <p>观看直播</p>
            <img
              :src="require('imgs/partyTop/double-arrow-right.png')"
              alt="double-arrow"
              class="double-arrow-right"
            />
          </div>
          <div class="current-themeName">{{ currentThemeName }}</div>
          <div v-if="currentPage === 1" class="player-container">
            <div class="content-player">
              <div v-if="videoUrlArr[0]" class="living-box">
                <Xgplayer
                  :url="aesDecrypt(videoUrlArr[1])"
                  :url-high="aesDecrypt(videoUrlArr[0])"
                  autoplay
                />
              </div>

              <img
                :src="require('imgs/partyTop/video-bottom-left.png')"
                class="video-bottom-left"
              />
              <img
                :src="require('imgs/partyTop/video-bottom-right.png')"
                class="video-bottom-right"
              />
            </div>
            <div class="congress-video-list-container">
              <div class="congress-video-list" data-scroll="true">
                <div
                  v-for="(v, i) in videoInfoListAfter"
                  :key="`video-title-item-${i}`"
                  class="list-item"
                  :class="[
                    {
                      'list-item-border':
                        i + 1 !== videoInfoListAfter.length &&
                        currentVideoInfoIndex !== i &&
                        currentVideoInfoIndex - 1 !== i,
                      'active-item':
                        currentVideoInfoIndex === i &&
                        videoInfoListAfter[i].videoPath,
                    },
                    setClass(i),
                  ]"
                  @click="onChoseVideoListItem(v, i)"
                >
                  <div
                    v-if="
                      currentVideoInfoIndex === i &&
                      videoInfoListAfter[i].videoPath
                    "
                    class="active-label"
                  >
                    <Jumping />
                    <p class="label-text">{{ v.videoSource }}</p>
                  </div>
                  <div class="item-title-box">
                    <img
                      v-show="currentVideoInfoIndex !== i"
                      :src="require('imgs/partyTop/play.webp')"
                      class="title-icon"
                    />
                    <p>{{ v.videoTitle }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="menu-container">
            <div class="menu-dynamic">
              <div class="dynamic-title">
                <p class="title-text">学习二十大</p>
                <p class="more-text" @click="onCheckAllDynamic">查看更多</p>
              </div>
              <div class="dynamic-list-fa">
                <img
                  :src="require('imgs/partyTop/page1-dynamic-shadow.png')"
                  alt="shadow"
                  class="page1-dynamic-shadow"
                />
                <div
                  v-if="dynamicRecommend.length > 0"
                  class="dynamic-list"
                  data-scroll="true"
                >
                  <div
                    v-for="(v, i) in dynamicRecommend.slice(0, 3)"
                    :key="`dynamic-item-${i}`"
                    class="dynamic-item"
                    @click="onChoseDynamicListItemPage1(v, i)"
                  >
                    <div class="item-title">
                      <p class="title-text">
                        {{ v.headline | textLenHandler(14) }}
                      </p>
                      <img
                        :src="require('imgs/partyTop/double-arrow-right.png')"
                        alt="double-arrow"
                        class="double-arrow-right"
                      />
                    </div>
                    <div class="item-content">
                      {{ filtersRichtext(v.memo) | textLenHandler(35) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="menu-right">
              <div class="book-result-fa">
                <div class="book-result" data-scroll="true">
                  <p @click="toPartyTop('/partyBuilding')">智慧党建</p>
                  <p @click="toPartyTop('/hometownAtlas')">图说洪雅变化</p>
                  <p @click="toPartyTop('/resultBook')">成果汇编</p>
                </div>
              </div>
              <div class="theme-box-fa">
                <Drop
                  v-if="dropShow"
                  :drop-option="coursewareBaseOption"
                  :selected-name="current2024CwareTheme"
                  :is-active="currentThemeName === '2024百部课件下基层'"
                  data-scroll="true"
                  class="drop-comp"
                  @onDropBarClick="onDropBarClick"
                  @onDropClick="onDropClick"
                />
                <div class="theme-box" data-scroll="true">
                  <p
                    v-for="(v, i) in themeList"
                    :key="`theme-item-${i}`"
                    class="theme-item"
                    :class="{
                      'active-theme-item': currentThemeName === v.title,
                      'two-line-theme-item': v.title.length > 9,
                      'two-line-active-theme-item':
                        v.title.length > 9 && currentThemeName === v.title,
                    }"
                    @click="onChoseTheme(v)"
                  >
                    {{ v.title }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <img
            :src="require('imgs/partyTop/home.png')"
            alt="home"
            class="home"
            @click="onReturnHome"
          />

          <Corporate class="corporate-comp" color="#fff" position="between" />
        </div>
      </template>
      <template #page2>
        <div class="page2">
          <div class="page2-title-box">
            <p class="page2-title">学习二十大</p>
          </div>

          <div class="page2-main-content">
            <div class="page2-left-container">
              <div class="rich-text-container" data-scroll="true">
                <p class="rich-text-title">
                  {{ currentDynamicInfo.headline || "" }}
                </p>
                <p class="rich-text-time">
                  {{ currentDynamicInfo.createtime | formatDate }}
                </p>
                <p
                  class="rich-text rich-text-content"
                  v-html="richTextImgHandler(currentDynamicInfo.memo)"
                ></p>
              </div>
            </div>
            <div>
              <div class="page2-right-container-fa">
                <!-- <img :src="require('imgs/partyTop/page2-dynamic-shadow.webp')" alt="shadow" class="page2-dynamic-shadow"> -->
                <div class="page2-right-container" data-scroll="true">
                  <div
                    v-for="(v, i) in dynamicInfoList"
                    :key="v.id"
                    class="list-item"
                    :class="[
                      {
                        'list-item-border':
                          i + 1 !== dynamicInfoList.length &&
                          currentDynamicIndex !== i &&
                          currentDynamicIndex - 1 !== i,
                        'active-item': currentDynamicIndex === i,
                      },
                      setClass(i),
                    ]"
                    @click="onChoseDynamicListItem(v, i)"
                  >
                    <p v-if="currentDynamicIndex === i" class="active-label">
                      <i class="el-icon-caret-right" />
                    </p>
                    <p class="item-title">
                      {{ filtersRichtext(v.headline) | textLenHandler(40) }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="page2-menu-container">
                <div class="book-result" data-scroll="true">
                  <p
                    v-for="(v, i) in dynamicTypeList"
                    :key="`page2-type-${i}`"
                    class="type-item"
                    :class="{ 'active-type-item': currentType === v.title }"
                    @click="onTypeClick(v)"
                  >
                    {{ v.title || "" }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <img
            :src="require('imgs/partyTop/top.png')"
            alt="top"
            class="top"
            @click="onTopClick"
          />
        </div>
      </template>
    </mv-full-page>
  </div>
</template>

<style lang="scss">
.full-page-wrapper .page-box {
  z-index: -3 !important;
}
</style>
<style lang="scss" scoped>
@import "./index.scss";
</style>
